<template>
  <DBox
    :id="'cmp-catalog-product-sidewindow-back_order'"
    :addButton="false"
    :addLink="false"
    @add_click="onAddGenres"
    :leftMenu="[
      {
        text: $t('export_excel'),
        value: 'export_excel',
        buttonStyle: 5
      },
    ]"
    @menuClick="onMenuItemClicked"
  >
    <div class="ut-fh ut-fc">
      <NTable
        class="dbox1"
        id="catalog-releases-sidewindow-related_tracks"
        :config="tableConfig"
        :headers="Headers"
        :items="list"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('account_name')">
              <span
                @click="onAccountClick(item)"
                class="ut-link ut-text-accent5"
                >{{ item["account_name"] }}</span
              >
            </td>
            <td v-bind="tdcon('date')">
              <span>{{ item["order_date"] }}</span>
            </td>
            <td v-bind="tdcon('qty')">
              <span class="txtov text-right">{{ item["order_qty"] }}</span>
            </td>

            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteOpenOrder(item)"
                  :alt="$t('delete')"
                  :title="$t('delete')"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <template slot="bottomRight">
      <div class="ut-flex ut-fh ut-mr-10px">
        <div style="color: var(--text-secondary)">
          {{ $t("total_open_orders") }}:
        </div>
        <div style="min-width: 40px; text-align: right">
          <b>{{ total_open_orders }}</b>
        </div>
      </div>
    </template>
    <!-- <div
      style="margin-right: 20px"
      class="dbox-bottom-right ut-flex ut-jend"
    >
      <div>
        <span style="color: var(--text-secondary)">Total Open Orders: </span>
        <b>{{ totalStock }}</b>
      </div>
    </div> -->
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { distributionOrderListLDTRoutes } from "../../../distribution/router/routes";
import { openNewTab } from "../../../../utility";
import { MHTTPCL } from "../../../../services/http/http-client";

export default {
  props: {
    selectedProductDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("account_name", { f: 2 }),
        createTableHeader("date", { f: 1 }),
        createTableHeader("qty", { f: 1, ta: "right" }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    total_open_orders() {
      return this.selectedProductDetails.total_open_orders || 0;
    },
    list: function () {
      return this.selectedProductDetails.open_orders || [];
    },
  },

  methods: {
    onDeleteOpenOrder: function (item) {
      console.log(item);
      this.$emit("delete", item);
    },

    onAddGenres: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_back_order",
          external_id: this.selectedProductDetails.product.product_id,
        },
      });
    },

    onAccountClick: function (item) {
      console.log(item);

      //distributionOrderListLDTRoutes

      this.$router.push({
        name: distributionOrderListLDTRoutes.names.tab,
        params: {
          order_id: item.order_id,
          tab: "overview",
        },
      });
    },

    onMenuItemClicked: function (item) {
      // console.log(item);
      if (item == "export_excel") {
        // https://dev.berlin3.com/updatecheck/label.pl?section=products&action=export_open_orders&product_id=<id>
        console.log(
          MHTTPCL.getBaseUrl() +
            `/label.pl?section=products&action=export_open_orders&product_id=${this.selectedProductDetails?.product?.product_id}`
        );
        openNewTab(
          MHTTPCL.getBaseUrl() +
            `/label.pl?section=products&action=export_open_orders&product_id=${this.selectedProductDetails?.product?.product_id}`
        );
      }
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-product-sidewindow-back_order {
  .dt-ntable {
    /* --ntable-height: 170px; */
  }
  .i-icon-box {
    background-color: var(--emerald);
    color: white;
    font-weight: 400;
    display: grid;
    place-items: center;
  }
}
</style>
